<template>
	<v-card class="elevation-3" color="white">
		<v-card-title class="secondary--text">
			<v-spacer></v-spacer>

			<v-icon color="secondary" @click="closeRequestDeleted()">mdi-close</v-icon>
		</v-card-title>
		<v-row no-gutters>
			<v-col>
				<div align="center" justify="center">
					<v-avatar color="white" size="100">
						<img class="white--text align-end" height="30" :src="require('@/assets/icons/✅.svg')" />
						<!--img src="https://cdn.vuetifyjs.com/images/john.jpg" alt="John" --/ -->
					</v-avatar>
				</div>
			</v-col>
		</v-row>
		<v-row no-gutters>
			<v-col>
				<h3 color="primary--text" class="title font-weight-bold" align="center" justify="center">Booking Request Deleted</h3>
			</v-col>
		</v-row>

		<v-row no-gutters>
			<v-col align="center" justify="center" class="pb-3">
				<v-btn class="subtitle primary--text font-weight-bold" justify="center" @click="goToLocumSearch">{{ getLabel('findProfessionals', 'Find Locums') }}</v-btn>
			</v-col>
		</v-row>
	</v-card>
</template>

<script>
import { bus } from '@/main';

export default {
	name: 'PracticeRequestCancelled',
	components: {},
	data: () => ({}),
	methods: {
		closeRequestDeleted() {
			this.$emit('dismiss', this);
		},
		goToLocumSearch() {
			bus.$emit('change-context', 'practice-locum-search');
			this.closeRequestDeleted();
		},
	},
};
</script>
